/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  add: {
    id: "b2b.projekty-grid.add",
    defaultMessage: "Add project"
  },
  title: {
    id: "b2b.projekty-grid.title",
    defaultMessage: "Projects"
  },
  deleteDialogTitle: {
    id: "b2b.projekty-grid.delete-dialog.title",
    defaultMessage: "Delete Project"
  },
  deleteDialogConfirm: {
    id: "b2b.projekty-grid.delete-dialog.confirm",
    defaultMessage: "Are you sure you want to delete this project?"
  }
});

export default () => useMessages(MESSAGES);
